import React, { ReactElement } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import '../Form/form.module.scss';

interface Option {
  name: string;
  code: string;
}

interface ProjectFilterMultiSelectProps {
  value: Option[];
  options: Option[];
  placeholder: string;
  onChange: (val: Option[]) => void;
}

const ProjectFilterMultiSelect = (
  props: ProjectFilterMultiSelectProps
): ReactElement => {
  const { value, options, onChange, placeholder } = props;
  return (
    <div className="col-12 md:col-6 lg:col-3">
      <MultiSelect
        className="multiselect"
        value={value}
        options={options}
        onChange={(e) => onChange(e.value)}
        optionLabel="name"
        placeholder={placeholder}
        showSelectAll={false}
        panelHeaderTemplate={<div />}
      />
    </div>
  );
};

export default ProjectFilterMultiSelect;
